<template>
    <div class="scan_detail_">
        <div class="scan_detail_header">基础信息</div>
        <div class="scan_detail_main">
            <div class="scan_row">
                <div class="scan_row_text">模具编号：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.mouldNum}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具循环次数：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.currentCycleTime}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具总次数：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.maxCycleTime}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具类型：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.mouldTypeName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具尺寸：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.sizeName}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具型号：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.mouldCode}}</div>
            </div>
            <div class="scan_row">
                <div class="scan_row_text">模具转向：</div>
                <div class="scan_row_data">{{massInfo&&massInfo.turnName}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            massInfo:[],//模具信息
            url:null,//传参
        }
    },
    mounted(){
        this.getDeviceInnfo()
    },
    methods:{
        //获取设备信息
        getDeviceInnfo(){
            this.url = window.location.href.split('?')[1].split('=')[1]
            window.document.title="模具信息"
            this.$api.Scan.searchModelInfo({mouldId:this.url}).then(res=>{
                if(res.statusMsg === 'ok'){
                    this.massInfo = res.data
                }else{
                    this.$message.warnning(res.statusMsg)
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.scan_detail_{
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    background-color: #0C264A;

    .scan_detail_header{
        height: 50px;
        color: rgba(255,255,255,.88);
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        background:url("../../assets/scan/scan_header_bg.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
    }
    .scan_detail_main{
        margin-top: 10px;

        .scan_row{
            display: flex;
            background: url("../../assets/scan/scan_main_rowbg.png") no-repeat;
            background-size: 100% 100%;
            margin-top: 10px;
            padding: 10px 15px;
            .scan_row_text{
                font-size: 15px;
                flex: none;
                color: rgba(255,255,255,.72);
            }
            .scan_row_data{
                font-size: 15px;
                flex: 1;
                color: #3DC8FF;
            }
        }
    }
}
</style>